export type MetadataResetOptions = {
  repository?: {owner: {login: string}; name: string} | null
  selectedRepository?: {owner: {login: string}; name: string} | null
}

export type MetadataResetActions<TProject, TMilestone> = {
  projectsToSet: TProject[]
  milestoneToSet: TMilestone | null
}

/**
 * Pure function that determines what metadata should be preserved/cleared
 * when resetting metadata for issue creation.
 */
export function getMetadataResetActions<TProject, TMilestone>(
  isSubIssue: boolean,
  preselectedProjects: TProject[],
  preselectedMilestone: TMilestone | null,
  options?: MetadataResetOptions,
): MetadataResetActions<TProject, TMilestone> {
  // For non-sub-issues, always clear everything
  if (!isSubIssue) {
    return {
      projectsToSet: [],
      milestoneToSet: null,
    }
  }

  // For sub-issues, check organization and repository context
  const isSameOrganization = options?.repository?.owner.login === options?.selectedRepository?.owner.login
  const isSameRepository = isSameOrganization && options?.repository?.name === options?.selectedRepository?.name

  // Projects: preserve if same organization and we have preselected projects
  const shouldPreserveProjects = isSameOrganization && preselectedProjects.length > 0
  const projectsToSet = shouldPreserveProjects ? preselectedProjects : []

  // Milestones: preserve if same repository and we have a preselected milestone
  const shouldPreserveMilestone = isSameRepository && !!preselectedMilestone
  const milestoneToSet = shouldPreserveMilestone ? preselectedMilestone : null

  return {
    projectsToSet,
    milestoneToSet,
  }
}
